import texts from './texts.json';

/**
 * Initial/empty form state for the broadcast messaging form.
 * Use for both initial useState values and for reset (e.g. after clear all).
 */
const InitialClientJourneyMessagingState = {
  message: '',
  characterCount: 0,
  fileAttachments: [],
  isEnabled: false,
  messageSendTime: new Date().setHours(9, 0, 0, 0),
};

const ToggleOption = {
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};

const ClientWeeklyJourneyMessagingToggleOptions = Object.entries(ToggleOption).map(([key, value]) => ({
  value,
  label: texts[value],
  key,
}));

export {
  InitialClientJourneyMessagingState,
  ToggleOption,
  ClientWeeklyJourneyMessagingToggleOptions,
};
